




















































import { Component, Prop, Vue, Emit, Watch } from "vue-property-decorator";
import * as Common from "@/agiles/common";
import * as Components from "@/agiles/components";
import {Editor} from '@/agiles/common/validator';

@Component
export default class AuditLogList extends Vue {
  @Prop({ default: "" }) public viewName: string;
  @Prop({ default: "" }) public layoutName: string;  
  @Prop({ default: Common.fileLayoutModes.export }) public fileMode: Common.fileLayoutModes;
  @Prop({ default: [] }) public fieldItems: Common.FieldItem[]; //Json文字列=>編集行為に応じて更新する
  @Prop({ default: true }) public enabled: boolean;
  @Prop({default: false}) public isLinked :boolean; //伝票・明細同時インポート
  @Prop({default: false}) public isUpdateOnly :boolean; //更新専用フラグ
  //未使用項目
  public pendingItems: Common.FieldItem[] = new Array();
  //使用項目
  public activeItems: Common.FieldItem[] = new Array();
  //ロードフラグ
  public isLoading: boolean = true;

　public allItems : Common.FieldItem[] = new Array();


  @Watch('fieldItems')
  public onChange(){
    //バインドを直接編集しない(直接編集しても良いかもしれないので後で確認する)
    this.activeItems = this.fieldItems;
    //fieldTypeのDB保存値は正しくない場合があるので修正する
    this.activeItems.forEach(item =>{
      var obj = this.allItems.find(obj =>obj.fieldName == item.fieldName) ;
      if (obj)item.fieldType = obj.fieldType;
    });
  }

  @Watch('viewName') 
  @Watch('layoutName')
  @Watch('isUpdateOnly')
  public onItemsChange(){
    if (this.viewName){
      this.isLoading = true;
      var query = new Common.FieldItemQuery();
      query.viewName = this.viewName;
      query.fileMode = this.fileMode;
      query.isLinked = this.isLinked;
      query.isUpdateOnly = this.isUpdateOnly;
      this.$api.execute(query).then(response => {

        //未使用項目を抽出する～使用項目に不要な項目があった場合に削除する処理があった方が良いかもしれない。
        var result: Common.FieldItem[] = (response as Common.LoadResult).result;
        var temp = new Array<Common.FieldItem>();
         result.forEach(item=>{
           if (item.fieldType == Common.fileFieldTypes.reference || item.fieldType == Common.fileFieldTypes.fixedValue 
            || this.fieldItems.find(obj =>obj.fieldName == item.fieldName) == null)
            temp.push(item);

           //プロビジョニングデータのFieldType不正に対応
           var obj = this.fieldItems.find(obj =>obj.fieldName == item.fieldName);
           if (obj)obj.fieldType = item.fieldType;

         });
        this.pendingItems = temp;

        this.allItems = result;

        this.isLoading = false;
      });
    }

  }

  public mounted(){
    this.onChange();
    this.onItemsChange();
  }
  
  //使用項目へ移動
  public onRight(){      
      var id =  (this.$refs.pendintList as Components.Grid).selectedId;
      var selectedItem = this.pendingItems[id];
      //参照・固定値は削除しない
      if (selectedItem.fieldType == Common.fileFieldTypes.field || selectedItem.fieldType == Common.fileFieldTypes.required) {
        this.$delete(this.pendingItems,id);
        this.$set(this.activeItems, this.activeItems.length, selectedItem);
        //移行元の最終行選択
        if (id == this.pendingItems.length)  
            (this.$refs.pendintList as Components.Grid).selectedId = this.pendingItems.length -1;
        
        this.$emit('update:fieldItems',this.activeItems); 
        //移行先選択
        this.$nextTick(()=> (this.$refs.fieldList as Components.Grid).selectedId = this.activeItems.length -1 );

      } else {
        this.onInsert(selectedItem);
      }
  }
  //未使用項目へ移動
  public onLeft(){
      var id =  (this.$refs.fieldList as Components.Grid).selectedId;
      var selectedItem = this.activeItems[id];
      this.$delete(this.activeItems,id);
      //参照・固定値は戻さない
      if (selectedItem.fieldType == Common.fileFieldTypes.field || selectedItem.fieldType == Common.fileFieldTypes.required) 
          this.$set(this.pendingItems, this.pendingItems.length, selectedItem);
　　//移行先選択
      (this.$refs.pendintList as Components.Grid).selectedId = this.pendingItems.length -1 
      
      this.$emit('update:fieldItems',this.activeItems);          
      //移行元の最終行選択          
      this.$nextTick(()=> {      
        if (id == this.activeItems.length)  
          (this.$refs.fieldList as Components.Grid).selectedId = this.activeItems.length -1;     
        } );

  }
  //上へ移動
  public onUpward(){
      var id =  (this.$refs.fieldList as Components.Grid).selectedId;
      if (id > 0){
        var selectedItem = this.activeItems[id];
        this.activeItems.splice(id,1);
        this.activeItems.splice(id - 1,0,selectedItem) ;
        this.$emit('update:activeItems',this.activeItems);    
        this.$emit('update:fieldItems',this.activeItems); 
        this.$nextTick(()=>{(this.$refs.fieldList as Components.Grid).selectedId = id -1;})
      }

  }
  //下へ移動
  public onDownward(){
      var id =  (this.$refs.fieldList as Components.Grid).selectedId;
      if (id < this.activeItems.length -1){
        var selectedItem = this.activeItems[id];
        this.activeItems.splice(id,1);
        this.activeItems.splice(id + 1,0,selectedItem) ;
        this.$emit('update:activeItems',this.activeItems);          
        this.$emit('update:fieldItems',this.activeItems); 
        this.$nextTick(()=>{(this.$refs.fieldList as Components.Grid).selectedId = id +1;     })
      }
  }
  //編集ダイアログ
  public editTitle:string = '';
  public editFieldName:string = '';
  public editFieldType:Common.fileFieldTypes = Common.fileFieldTypes.field;  
  public editReferenceName:string = '';
  public editAliasName:string = '';  
  public editFixedValue:string = '';
  public editFormat:string = '';

  public editIndex :number;
  public editItem :Common.FieldItem;
  public insertMode : boolean = false;
  public showDialog:boolean = false;
  public dialogEditor: Editor = new Editor();

  public onInsert(selected: Common.FieldItem){
    this.insertMode = true;
    this.editItem = selected.copy();
    this.onEditStart(this.editItem);    
  }
  //編集
  public onEdit(){
    this.insertMode = false;
    var id = (this.$refs.fieldList as Components.Grid).selectedId;
    this.editItem = this.activeItems[id];
    this.onEditStart(this.editItem);
  }  

  public onEditStart(selected: Common.FieldItem){
     this.dialogEditor = new Editor();
     this.editTitle = selected.fieldType == Common.fileFieldTypes.reference ? '参照編集' : selected.fieldType == Common.fileFieldTypes.fixedValue ? '固定値編集' : '項目編集';
     this.editFieldName = selected.fieldType == Common.fileFieldTypes.reference ? selected.fieldName.substring(0,selected.fieldName.indexOf(".")):selected.fieldName;
     this.editFieldType = selected.fieldType;    
     var refName = selected.fieldType == Common.fileFieldTypes.reference ? selected.fieldName.substring(selected.fieldName.indexOf(".") + 1):'';
     this.editReferenceName = refName == '*' ? '' : refName;
     this.editAliasName = selected.aliasName;
     this.editFixedValue = selected.fixedValue;
     this.editFormat = selected.format;
     
     this.showDialog = true;
  }

  public onEditComplete(event:any){
    
    if (this.dialogEditor.validator.validate()){
      
      var selected = this.editItem;
      selected.aliasName = this.editAliasName;
      selected.format =  this.editFormat;

      if (selected.fieldType == Common.fileFieldTypes.reference) 
        selected.fieldName = this.editFieldName + '.' + this.editReferenceName;
      if (selected.fieldType == Common.fileFieldTypes.fixedValue)
        selected.fixedValue = this.editFixedValue;      
      if (this.insertMode){
        this.activeItems.push(this.editItem);
        //最終行選択
        this.$nextTick(()=>(this.$refs.fieldList as Components.Grid).selectedId = this.activeItems.length -1)
      }

      this.$emit('update:fieldItems',this.activeItems);     

    } else {
      event.preventDefault();
      return;
    }
          
  }
}
